function auditEmptyMode () {
  return {
    restrict: 'E',
    scope: {
      type: '@'
    },
    templateUrl: '/audit/directives/audit-empty-mode/audit-empty-mode.html?$$REVISION$$'
  }
}

export { auditEmptyMode }
